import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "law-page" }
const _hoisted_2 = { class: "top-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "banner-info" }
const _hoisted_5 = { class: "btn" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "news-main" }
const _hoisted_8 = { class: "service-box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "scene-box" }
const _hoisted_11 = { class: "item bg1" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "item bg2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "item bg3" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "item bg4" }
const _hoisted_18 = ["src"]

import { baseUrl } from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndustryNews',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(baseUrl) + '/product-bg.png',
        alt: "Banner",
        class: "banner-image"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "行业资讯跟踪", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "space" }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "info" }, "专注于医疗垂直领域大数据服务，依托海量权威公众号文章资源，构建覆盖临床诊疗、医学研究政策解读、健康科普、行业趋势的全维度知识库。", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info" }, "严格遵循《网络安全法》《医疗数据合规指南》，采用去标识化处理技术，已为12家医疗客户提供合规数据资产解决方案。让数据成为您的“医疗战略望远镜”", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _unref(baseUrl) + '/btn.png',
            class: "btn",
            alt: ""
          }, null, 8, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "section-title" }, [
        _createElementVNode("h2", null, "服务介绍"),
        _createElementVNode("div", { class: "title-underline" })
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"info-box\" data-v-ea586786><div class=\"title\" data-v-ea586786><span class=\"bold\" data-v-ea586786>聚合卫健委、药监局等官方新闻发布平台与500+垂直领域优质公众号。</span> 通过AI语义分析+人工医学审核双引擎，实现： </div><div class=\"info-line\" data-v-ea586786><div class=\"label\" data-v-ea586786>🔍 <span class=\"bold\" data-v-ea586786>权威溯源：</span></div><div class=\"desc\" data-v-ea586786>实时抓取政府公告、权威机构白皮书、三甲医院专家解读，确保信息源头可靠</div></div><div class=\"info-line\" data-v-ea586786><div class=\"label\" data-v-ea586786>🔍 <span class=\"bold\" data-v-ea586786>动态预警：</span></div><div class=\"desc\" data-v-ea586786>监测医保政策调整、器械审批动态、疾病流行趋势，抢占行业先机</div></div><div class=\"info-line\" data-v-ea586786><div class=\"label\" data-v-ea586786>🔍 <span class=\"bold\" data-v-ea586786>深度解构：</span></div><div class=\"desc\" data-v-ea586786>关联分析政策导向与市场数据（如集采影响、科室建设风向），输出可视化报告</div></div><div class=\"info-line\" data-v-ea586786><div class=\"label\" data-v-ea586786>🔍 <span class=\"bold\" data-v-ea586786>精准触达：</span></div><div class=\"desc\" data-v-ea586786>支持按 <span class=\"bold\" data-v-ea586786>产品关键词、地域、机构类型</span> 定制数据包，直击科研、投资、运营场景需求 </div></div></div>", 1)),
        _createElementVNode("img", {
          src: _unref(baseUrl) + '/news-table.png',
          class: "table-img",
          alt: ""
        }, null, 8, _hoisted_9)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-title" }, [
        _createElementVNode("h2", null, "适用场景"),
        _createElementVNode("div", { class: "title-underline" })
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: _unref(baseUrl) + '/title1.png',
            class: "title",
            alt: ""
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            src: _unref(baseUrl) + '/title2.png',
            class: "title",
            alt: ""
          }, null, 8, _hoisted_14)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("img", {
            src: _unref(baseUrl) + '/title3.png',
            class: "title",
            alt: ""
          }, null, 8, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("img", {
            src: _unref(baseUrl) + '/title4.png',
            class: "title",
            alt: ""
          }, null, 8, _hoisted_18)
        ])
      ])
    ])
  ]))
}
}

})